// extracted by mini-css-extract-plugin
export var card = "_sk-0";